/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { get } from 'lodash';
import NumberFormat from '../../utils/NumberFormat';
import FNumberFormatKm from '../../utils/FNumberFormatKm';
import { roundToTwoDecimal } from '../../utils/numberUtils';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 5,
    marginLeft: 2,
    justifyContent: 'flex-start',
    width: '100%',
  },
  billTo: {
    // padding: 3,
    // fontFamily: 'Helvetica-Oblique',
    fontStyle: 'bold',
    textDecoration: 'underline',
  },
  invoiceDateContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  label: {
    width: 100,
    fontStyle: 'bold',
  },
  conteudo: {
    width: 100,
  },
});

function InvoiceNo({ dados }) {
  const despesas = get(dados, 'Despesas', []);
  const consumo = (roundToTwoDecimal(dados.consumo) || 0).toFixed(2);
  const peso = (roundToTwoDecimal(dados.peso) || 0).toFixed(2);
  const kmRodado = (
    roundToTwoDecimal(dados.kmretorno - dados.kmsaida) || 0
  ).toFixed(2);
  const kmPorConsumo = roundToTwoDecimal(
    (kmRodado || 0) / (consumo || 1)
  ).toFixed(2);
  const kmconsumoPorPeso = roundToTwoDecimal(
    (kmRodado || 0) / (dados.consumo || 1) / (dados.peso || 1)
  ).toFixed(2);
  const totalDespesasOleDiesel = despesas
    .filter((item) => item.TipoDespesa.flag_combustivel === true)
    .map((item) => parseFloat(item.valor))
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    .toFixed(2);
  const oleDiesel = Number.parseFloat(
    totalDespesasOleDiesel / dados.consumo
  ).toFixed(2);
  return (
    <View style={styles.headerContainer}>
      <Text style={styles.billTo}>Consumo:</Text>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Km Rodado: </Text>
        <Text style={styles.conteudo}>{FNumberFormatKm(kmRodado)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>P.M. Diesel(por L): </Text>
        <Text style={styles.conteudo}>{NumberFormat(oleDiesel)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Cons.Diesel(L): </Text>
        <Text style={styles.conteudo}>{NumberFormat(consumo)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Peso(T): </Text>
        <Text style={styles.conteudo}>{NumberFormat(peso)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Média Km/L: </Text>
        <Text style={styles.conteudo}>{NumberFormat(kmPorConsumo)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Fator KmL/T: </Text>
        <Text style={styles.conteudo}>{NumberFormat(kmconsumoPorPeso)}</Text>
      </View>
    </View>
  );
}

export default InvoiceNo;
